/**
 * Labstep
 *
 * @module models/partial-entity
 * @desc Typescript export class for any entity
 */

import { ICONS } from 'labstep-web/constants/icons';
import { snakeCase } from 'lodash';
import type { SemanticICONS } from 'semantic-ui-react';

export class PartialEntity {
  public static entityName: string;

  public static readonly idAttr: string = 'id';

  public constructor(data: Partial<PartialEntity>) {
    Object.assign(this, data);
  }

  public guid!: string;

  public id!: string | number;

  public entity_class!: string;

  public display_name!: string;

  public parent!: PartialEntity;

  public custom_identifier!: string;

  public is_root!: boolean;

  public is_template!: boolean;

  public is_draft!: boolean;

  public outer_location!: PartialEntity;

  createdAt!: string;

  set created_at(value: string) {
    this.createdAt = value;
  }

  get created_at() {
    return this.createdAt;
  }

  get entityClassSnakeCase(): string {
    return snakeCase(this.entity_class);
  }

  get displayName(): string {
    if (this.custom_identifier) {
      return `${this.custom_identifier} - ${this.display_name}`;
    }
    return this.display_name;
  }

  get icon(): SemanticICONS {
    const templateEntities = [
      'device',
      'experiment_workflow',
      'resource',
    ];
    if (
      this.is_template &&
      templateEntities.includes(this.entityClassSnakeCase)
    ) {
      return ICONS[
        this.entityClassSnakeCase as
          | 'device'
          | 'experiment_workflow'
          | 'resource'
      ].template;
    }
    return (
      ICONS[this.entityClassSnakeCase as keyof typeof ICONS]
        ?.primary || 'bookmark'
    );
  }
}
